// src/services/CountryService.js
import api from "./api";

export function getField(page = 1, limit = 10, search = "") {
    return api.get(`/field?page=${page}&limit=${limit}&search=${search}`);
}

export function getFieldById(id) {
    return api.get(`/field/${id}`);
}

export function addField(data) {
    return api.post("/field", data);
}

export function updateField(id, data) {
    return api.put(`/field/${id}`, data);
}

export function deleteField(id) {
    return api.delete(`/field/${id}`);
}
